<template>
    <div class="ancestor">
        <div class="theme-titles">
            <div class="theme-text">
                <img :src="require('assets/image/solution-img/sortware2.png')" />
                <span class="theme-name">软件系统</span>
                <span class="boult">&gt;</span>
            </div>
        </div>
        <div class="header">
            <div>
                <p>RFID软件系统主要完成信息的处理和应用，RFID系统中的软件组件主要完成数据信息的存储、管理以及对RFID标签的读写控制，是独立于RFID硬件之上的部分。</p>
                <p>一般，RFID软件组件包含有边沿接口、中间件、企业应用接口、应用软件、云数据服务。</p>
            </div>
        </div>
        <div class="sortware">
            <div class="title">软件系列</div>
            <div class="wrapper">
                <ul>
                    <li>
                        <p>PDA读写器SDK</p>
                        <p>手持式PDA软件</p>
                        <p>手持移动式数据采集器，底层读取RFID功能封装接口</p>
                    </li>
                    <li>
                        <p>通道门式读写器软件</p>
                        <p>通道式读卡器</p>
                        <p>固定式数据采集器，批量读卡器</p>
                    </li>
                    <li>
                        <p>中间件Middleware接口</p>
                        <p>前端接入工控采集系统软件</p>
                        <p>包含数据冗余处理，数据接口调用及返回等功能，企业应用接口</p>
                    </li>
                    <li>
                        <p>司机端APP</p>
                        <p>货运司机安装在手机端，在承接上游发货与下游交货的时候，仅需扫描二维码即可</p>
                        <p>监测货物在途的物流信息</p>
                    </li>
                    <li>
                        <p>数据云</p>
                        <p>云端系统</p>
                        <p>数据汇集、分析，企业应用接口</p>
                    </li>
                </ul>
            </div>
            <!-- 软件技术结构 -->
            <div class="title">软件技术结构</div>
            <div class="imgs">
                <img src="~assets/image/solution-img/sortware.png" alt="软件技术结构">
            </div>
        </div>
    </div>
</template>

<script>
export default {};
</script>

<style lang="less" scoped>
.ancestor {
    background: #fff;
    width: 100%;
    margin-top: 30px;
    padding-bottom: 30px;

    .theme-titles {
        height: 55px;
        padding: 10px 30px;
        background: #fff;
        border-bottom: 5px solid #ff6000;
        font-size: 16px;
        .theme-text {
            float: left;
            width: 200px;
            > img {
                vertical-align: middle;
                margin-top: -10px;
            }
            .boult {
                margin-left: 5px;
                font-weight: bold;
                color: #ff6000;
            }
            .theme-name {
                font-weight: bold;
                display: inline-block;
                // margin-top: 6px;
                margin-left: 12px;
            }
        }
    }
    .header {
        margin: 30px;
        > div {
            //   width: 500px;
            height: 85px;
            p {
                text-indent: 2em;
            }
            p:last-of-type {
                margin-top: 10px;
            }
        }
    }
    .sortware {
        margin-top: 20px;
        .title {
            width: 100%;
            height: 50px;
            background: #ff6000;
            text-align: center;
            line-height: 50px;
            color: #fff;
            font-size: 24px;
        }
        .wrapper {
            margin-top: 30px;
            ul {
                height: 568px;
                list-style: none;

                li {
                    float: left;
                    width: 255px;
                    height: 250px;
                    background: #ffc4a0;
                    margin: 10px;
                    text-align: center;
                    font-weight: bold;
                    p:first-of-type {
                        margin-top: 42px;
                    }
                    p {
                        padding: 11px 10px 3px 10px;
                    }
                }
            }
        }
        .imgs {
            margin-left: 170px;
            img {
                width: 600px;
            }
        }
    }
}
</style>